import apiClient from '../utils/apiClient';

/**
 * Obtiene la lista de destinos que coinciden con la búsqueda
 * 
 * @param {string} destination - Palabra o frase a buscar
 * @returns {Promise<Array< Destination >>} - La lista de destinos que coinciden con la búsqueda
 */
export const OpenpayVpos = async (metadata) => {
  try {
    const response = await apiClient.post(`/openpay/vpos`, metadata);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const ConektaVpos = async (metadata) => {
  try {
    const response = await apiClient.post(`/conekta/vpos`, metadata);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const booking = async (idTransaccion, carrito) => {
  try {
    const response = await apiClient.post(`/booking/reservar`, idTransaccion, carrito);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};



export const getInfoReserva = async (idReserva) => {
  try {
    const response = await apiClient.post(`/reserva/info`, idReserva);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const bookingPP = async (idTransaccion, carrito) => {
  try {
    const response = await apiClient.post(`/booking/reservar/pp`, idTransaccion, carrito);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getInfoReservaPP = async (idReserva) => {
  try {
    const response = await apiClient.post(`/reserva/info/pp`, idReserva);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};